<template>
  <div>
    <!-- 标题 -->
    <h3 v-if="title">{{ title }}</h3>
    <!-- TAB目录 -->
    <template>
      <Tabs style="height: 40px" :value="query.typeId" @on-click="(e) => everyType(e)">
        <TabPane
          label="全部分类"
          icon="ios-menu-outline"
          :name="''"
          :capture-focus="true"
        ></TabPane>
        <TabPane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.model"
          :name="tab.id"
        >
          {{ tab.model }}</TabPane
        >
      </Tabs>
    </template>
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="menus && menus.length > 0"
    >
      <Menu
        mode="horizontal"
        :active-name="menu_name"
        @on-select="selectMenu"
        style="width: 100%"
      >
        <div v-for="(v, k) in menus"  style="display:inline-block;" :key="k">
          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
            <Badge
              :overflow-count="10000000"
              v-if="v.badge && v.badge.count"
              :count="v.badge.count"
              :offset="[18, -3]"
            >
              {{ v.label }}
            </Badge>
            <span v-if="!(v.badge && v.badge.count)">
              {{ v.label }}
            </span>
          </MenuItem>
        </div>
      </Menu>
    </Row>
    <Row
      :gutter="8"
      style="margin: 0px 0 0 0; width: 100%"
      v-if="filters && filters.length > 0"
    >
      <Collapse style="width: 100%" v-model="value1">
        <!--  -->
        <Panel style="width: 100%" name="2">
          展开搜索条件
          <Form
            ref="formQuery"
            :label-width="75"
            :label-position="left"
            :label-colon="true"
            :model="query"
            style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            "
            slot="content"
          >
            <Col
              span="3"
              :xxl="6"
              :xl="4"
              :lg="6"
              :md="8"
              :sm="12"
              :xs="24"
              style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              "
            >
              <Button icon="ios-search" type="info" @click="search" style="width: 90px"
                >搜索
              </Button>
              <Button
                icon="ios-close-circle"
                type="error"
                @click="clearFilter"
                style="width: 90px; margin-right: 15px"
                >重置
              </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <div style="margin-bottom: 0; display: flex">
                    <Input
                      :key="k"
                      :placeholder="'最小' + v.label"
                      clearable
                      v-model="query[v.name1]"
                    ></Input>
                    <div>~</div>
                    <Input
                      :key="k"
                      :placeholder="'最大' + v.label"
                      clearable
                      v-model="query[v.name2]"
                    ></Input>
                  </div>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'string' || v.type === 'text' || v.type === 'input'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <Input
                    :key="k"
                    :placeholder="v.label"
                    clearable
                    v-model="query[v.name]"
                    @keyup.enter.native="v.KeyEnter"
                  ></Input>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    :filterable="true"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'selectsearch'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    remote
                    filterable
                    @keyup.enter.native="v.KeyEnter"
                    :remote-method="v.remoteMethod"
                    style="width: 193px"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'datetimerange'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="daterange"
                    v-model="query1[v.name + v.lable]"
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy-MM-dd"
                    placeholder="选择时间"
                    :options="optionsData"
                    @on-change="
                      (val) => {
                        timeDateChange(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                v-else-if="v.type === 'distpicker'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormAddress
                  @on-change="
                    (val) => {
                      onAddressChange(val, v.name);
                    }
                  "
                  style="width: 100%"
                ></FormAddress>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'addressInfo'"
                style="width: auto; margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <v-distpicker
                    :disabeld="disabeld"
                    type="addressInfo"
                    :province="province"
                    :city="city"
                    :area="area"
                    @selected="v.onSelect"
                  ></v-distpicker>
                </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>

    <!-- 操作 -->
    <Row
      :gutter="8"
      style="margin: 10px 0 0 0; width: 100%"
      v-if="actions && actions.length > 0"
    >
      <div v-for="(v, k) in actions" :key="k" style="display: inline-flex">
        <Button
          style="margin-right: 10px"
          v-if="v.show ? true : false"
          :size="v.size || 'default'"
          :type="v.type || 'warning'"
          v-auth="v.auth"
          v-authTwo="v.authTwo"
          :icon="v.icon || ''"
          @click="v.onClick"
          >{{ v.label }}
        </Button>
      </div>
    </Row>

    <!-- 表格 -->
    <Row :gutter="8" style="margin: 10px 0 0 0; width: 100%">
      <edit-table
        ref="tablelist"
        :query="query"
        :table="table"
        :order="table.order || ''"
        :rowClassName="table.rowClassName"
        :output="table.output"
        :border="table.border"
        :stripe="table.stripe"
        :header="table.header"
        :footer="table.footer"
        :columns-list="tableCols"
        :handleSpan="handleSpan"
        @on-select="handleSelect"
        @on-edit="handleEdit"
        @on-info="handleInfo"
        @on-del="handleDel"
      >
        <div slot="action" v-if="tactions && tactions.length > 0">
          <div
            v-for="(v, k) in tactions"
            :key="k"
            style="margin-right: 10px; display: inline-flex"
          >
            <Button
              :size="v.size || 'default'"
              :type="v.type || 'primary'"
              v-auth="v.auth"
              :icon="v.icon || ''"
              :disabled="v.disabled"
              @click="v.onClick"
              >{{ v.label }}
            </Button>
          </div>
        </div>
      </edit-table>
    </Row>

    <!-- 侧栏详情 -->
    <Drawer title="详情" :closable="true" width="640" v-model="drawerBox">
      <component :is="drawerName" :kv="drawerKv"></component>
    </Drawer>
    <!-- 动态组件 -->
    <component
      v-for="(item, index) in extRender || []"
      :key="index"
      :ref="item"
      :is="item"
    ></component>
  </div>
</template>
<script>
import baseView from "./baseView.vue";
import FormAddress from "../common/form/formAddress";
import EditTable from "../common/table/editTable.vue";

export default {
  extends: baseView,
  components: {
    FormAddress,
    EditTable,
  },
  data() {
    return {
      button1: "北京",
      //控制搜索条件手风琴默认是否展开0:关闭 1:展开
      value1: "0",
      testvalue: "",
      filterKey: "",
      title: "",
      hospitaltype: "",
      selectLike: "",
      table: {
        mname: "",
        key: "",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        rowClassName: () => {},
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      item: [],
      drawerBox: false, // 侧栏详情
      drawerName: "info", // 动态渲染的组件
      drawerKv: "", // 详情主键
      pass: {
        model: false,
        sloading: false,
        kv: null,
        status: 0,
        content: "",
        modelMap: false,
      },
      pass2: {
        model2: false,
        kv: null,
        content: "",
      },
      selected: "",
      router: { add: "", edit: "" },
      actions: [],
      tactions: [],
      menu_name: "",
      menus: [],
      query: {},
      query1: {},
      filters: [],
      tableCols: [],
      logisticsData: [],
      orderLength: "",
      saledLength: "",
      optionsData: {
        disabledDate(date) {
          return date && date.valueOf() >= new Date();
        },
        shortcuts: [
          {
            text: "本周",
            value() {
              const end = new Date();
              const start = new Date();
              const weekday = start.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
              start.setDate(start.getDate() - weekday + 1); //往前算（weekday-1）天，年份、月份会自动变化
              return [start, end];
            },
          },
          {
            text: "本月",
            value() {
              const end = new Date();
              var nowMonth = end.getMonth(); //当前月
              var nowYear = end.getFullYear(); //当前年
              const start = new Date(nowYear, nowMonth, 1);
              return [start, end];
            },
          },
          {
            text: "上个月",
            value() {
              const data = new Date();
              var nowMonth = data.getMonth(); //当前月
              var nowYear = data.getFullYear(); //当前年
              const start = new Date(nowYear, nowMonth - 1, 1);
              const end = new Date(nowYear, nowMonth, 0);
              return [start, end];
            },
          },
          {
            text: "1~2年",
            value() {
              const data = new Date();
              var nowMonth = data.getMonth(); //当前月
              var nowYear = data.getFullYear(); //当前年
              var nowDate = data.getDate(); //当天
              const start = new Date(nowYear - 2, nowMonth, nowDate);
              const end = new Date(nowYear - 1, nowMonth, nowDate);
              return [start, end];
            },
          },
          {
            text: "3~5年",
            value() {
              const data = new Date();
              var nowMonth = data.getMonth(); //当前月
              var nowYear = data.getFullYear(); //当前年
              var nowDate = data.getDate(); //当天
              const start = new Date(nowYear - 3, nowMonth, nowDate);
              const end = new Date(nowYear - 5, nowMonth, nowDate);
              return [start, end];
            },
          },
          {
            text: "5年以上",
            value() {
              const data = new Date();
              var nowMonth = data.getMonth(); //当前月
              var nowYear = data.getFullYear(); //当前年
              var nowDate = data.getDate(); //当天
              const start = new Date(1970, nowMonth, nowDate);
              const end = new Date(nowYear - 5, nowMonth, nowDate);
              return [start, end];
            },
          },
        ],
      },
    };
  },
  extRender() {
    // 动态选择组件，["xxx","bbb"]
    return null;
  },
  watch: {
    query() {
      this.$forceUpdate();
    },
    filters() {
      this.$forceUpdate();
    },
  },
  created() {
    let url = window.location.href;
    this.filterKey = url.split("#")[1];
    // false "" undefined 0  null  ===  if (a){
    // }
    if (sessionStorage.getItem(this.filterKey)) {
      if (JSON.parse(sessionStorage.getItem(this.filterKey))) {
        this.query = JSON.parse(sessionStorage.getItem(this.filterKey));
      }
    }
    let filterKeyTIme = sessionStorage.getItem(this.filterKey + "time");
    if (filterKeyTIme) {
      if (JSON.parse(sessionStorage.getItem(this.filterKey + "time"))) {
        this.query1 = JSON.parse(sessionStorage.getItem(this.filterKey + "time"));
      }
    }

    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }

    // 表格行样式
    this.table.rowClassName = (row, index) => {
      return this.rowClassName(row, index);
    };
  },
  mounted() {
    this.search();
    // 获取目录上的徽标
    this.getMenuBadge();
  },
  methods: {
    everyType(e) {
      this.query.typeId = e;
      // this.$refs.tablelist.init();
      this.search()
    },
    getMenuBadge() {
      let that = this;
      if (this.menus) {
        // 查询徽标数
        for (let index = 0; index < this.menus.length; index++) {
          const ee = this.menus[index];
          if (ee.badge && ee.badge.scene && ee.badge.mname) {
            let q = {};
            q.scene = ee.badge.scene;
            $utils.api
              .load(ee.badge.url || ee.badge.mname, q, "get", {
                loading: false,
                login: false,
                toast: false,
                toasterror: false,
              })
              .then((res) => {
                if (res.status && res.data) {
                  let badge = res.data[ee.badge.scene];
                  if (badge) {
                    that.menus[index].badge.count = badge;
                    that.$forceUpdate();
                  }
                }
                if (res.status && res.total) {
                  let badge = res.total;
                  if (badge) {
                    that.menus[index].badge.count = badge;
                    that.$forceUpdate();
                  }
                }
              });
          }
        }
      }
    },
    search() {
      if (this.query1) {
        sessionStorage.setItem(this.filterKey + "time", JSON.stringify(this.query1));
      } else {
        sessionStorage.removeItem(this.filterKey + "time");
      }
      if (this.query) {
        sessionStorage.setItem(this.filterKey, JSON.stringify(this.query));
      } else {
        sessionStorage.removeItem(this.filterKey);
      }

      // 取消多选框，否则有残留数据
      this.selected = "";
      this.$refs.tablelist.page.page = 1;

      this.$refs.tablelist.init();
    },
    exportTable() {
      $utils.api.load(this.table.url.export).then((resp) => {});
    },

    onAddressChange(val, field) {
      let province = val.province || {};
      let city = val.city || {};
      let area = val.area || {};
      this.query[field] = {
        field: field,
        province_code: province.code,
        city_code: city.code,
        area_code: area.code,
      };
    },

    clearFilter() {
      // console.log("Clear filter")
      this.query1 = {};
      this.query = {};
      sessionStorage.removeItem(this.filterKey);
      sessionStorage.removeItem(this.filterKey + "time");
      this.$refs.formQuery.resetFields();
      //列表单独字段请求置空
      this.$refs.tablelist.page.page = 1;
      this.$refs.tablelist.init();
    },
    exportData(filename = "", is_all = 0) {
      // 调用table导出
      const ids = this.selected;
      this.$refs.tablelist.exportData(4, ids, filename, is_all);
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    loadFiltersFieldDrop(type, field, param = {}) {
      // 通过pk查询字典数据
      let q = param;
      let apiname = "";
      if (type == "shop") {
        apiname = "shopDropList";
      }
      if (type == "shop_store") {
        apiname = "shopStoreDropList";
      }
      if (type == "product") {
        apiname = "productDropList";
      }
      if (type == "product_class") {
        apiname = "productClassDropList";
      }
      if (type == "help_class") {
        apiname = "helpClassDropList";
      }
      if (type == "auth_type") {
        apiname = "authTypeDropList";
      }
      if (!apiname) {
        return;
      }
      $utils.api.load(apiname, q).then((res) => {
        if (res && res.data) {
          let ll = res.data;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.value;
            xx.name = element.name;
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == field && element.type == "select") {
              this.filters[index]["dropList"] = dropList;
            }
          }
        }
      });
    },
    // 通过name查询filters下标
    indexOfName(name = "", filters = []) {
      if (!name) {
        return -1;
      }
      if (!filters) {
        filters = this.filters || [];
      }
      for (let index = 0; index < this.filters.length; index++) {
        const element = this.filters[index];
        if (element && element.name == name) {
          return index;
        }
      }
      return -1;
    },
    timeDateChange(val, field) {
      this.query.begin = val[0];
      this.query.end = val[1];
    },
    // 合并行列
    handleSpan({ row, column, rowIndex, columnIndex }) {},
    rowClassName(row, index) {
      return "";
    },
    toAdd(e, name = "") {
      let url = this.table.router.add || this.toLine(this.table.mname) + "_add";
      if (name && name !== "" && name !== undefined) {
        url = name;
      }
      $utils.url.push({ name: url, query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row[this.table.key];
      let url = this.table.router.edit || this.toLine(this.table.mname) + "_edit";
      $utils.url.push({ name: url, query: { action: "edit", kv: kv } });
    },
    handleSelect(selected, row) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
      }
      this.item = selected;
      this.selected = ids_arr.join(",");
    },
    handleDel(row) {},
    handleInfo(row) {
      let kv = row[this.table.key];
      // 打开详情
      this.drawerBox = true;
      this.drawerKv = kv;
    },

    // 点击列表
    handleRowClick(e) {
      if (typeof this.RowCLick == "function") {
        this.RowCLick(e);
      }
    },
    approveAdd() {
      this.$bus.emit("approveAdd");
      this.$Modal.remove();
      let q = this.item;
      for (let index = 0; index < q.length; index++) {
        q[index].deskId = this.deskData.rows[0].id;
      }
      $utils.api.load(`admin/approve/add`, q, "Post").then((res) => {
        if (res.code === 200) {
          $utils.toast.success(res.msg);
          this.$refs.tablelist.page.page = 1;
          this.$refs.tablelist.init();
        }
      });
    },
  },
};
</script>
<style lang="less">
.modelMap {
  position: relative;
}

#container {
  margin: 0 auto;
}

.ivu-modal-confirm-footer {
  display: none;
}

.single-page {
  overflow: hidden;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: #2d8cf0 !important;
  border-bottom: 2px solid #2d8cf0 !important;
}

.ivu-form .ivu-form-item-label {
  text-align: left !important;
  padding: 10px 0 10px 0 !important;
  //font-size: 10px !important;
}

.ivu-form-item-content {
  left: 0px;
}
</style>
